<template>
  <transition v-on:enter="enter" name="window">
    <div
      class="wnd_outer"
      v-show="_visible"
      :style="{
        width: this._width,
        height: this._height,
        left: this._x,
        top: this._y,
        zIndex: 999,
        minWidth: 300 + 'px',
        minHeight: 200 + 'px',
        maxWidth: windowWidth - 40 + 'px',
        maxHeight: windowHeight - 40 + 'px',
        overflow: 'hidden',
      }"
    >
      <div class="caption" @mousedown.prevent="mousedown">
        サマリー
        <i-icon size="18" type="ios-close" @click="closeButtonClicked" class="close" />
      </div>
      <div class="wnd_inner" ref="wndInner">
        <ConvertContents :type="type" />
      </div>
      <div class="mod_size" @mousedown="startSizeChange">
        <span style="top: 4px;left: -1px; width: 150%;"></span>
        <span style="top: 9px;"></span>
      </div>
    </div>
  </transition>
</template>

<script>
import { Icon } from 'view-design'
import ConvertContents from './Contents'
import ConvertRepository from '@/repositories/convertRepository'
export default {
  components: {
    'i-icon': Icon,
    ConvertContents,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      x: null,
      y: null,
      cursorOffset: { x: 0, y: 0 },
      cursorStartPos: null,
      stateAtSizeChangeStarted: { width: 0, height: 0, cursorX: 0, cursorY: 0 },
      width: this.initialWidth,
      height: this.initialHeight,
      activeTab: null,
      activeResultData: {},
      activeResultShopId: null,
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    caption: {
      type: String,
      default: '',
    },
    initialPosition: {
      type: Array,
      default: null,
    },
    initialWidth: {
      type: Number,
      default: 0,
    },
    initialHeight: {
      type: Number,
      default: 0,
    },
    windowLoading: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
      required: true,
      validator: function(value) {
        return ['investment', 'residence'].indexOf(value) !== -1
      },
    },
  },
  computed: {
    user() {
      return this.$store.getters['User/getUser']
    },
    _visible: function() {
      return this.visible
    },
    _width: function() {
      return this.width ? `${this.width}px` : 'auto'
    },
    _height: function() {
      return this.height ? `${this.height}px` : 'auto'
    },
    _x: function() {
      let x = this.x
      if (x <= 16) x = 16
      if (x >= this.windowWidth - 80) x = this.windowWidth - 80
      return `${x}px`
    },
    _y: function() {
      let y = this.y
      if (y <= 16) y = 16
      if (y >= this.windowHeight - 80) y = this.windowHeight - 80
      return `${y}px`
    },
  },
  watch: {
    _visible() {
      if (this._visible) {
        // ローカルストレージから前回のwindowサイズを取得
        const summaryWindowParams = JSON.parse(localStorage.getItem('summaryWindowParams'))
        if (summaryWindowParams) {
          this.initialWidth = summaryWindowParams.width
          this.initialHeight = summaryWindowParams.height
        }

        // window表示位置をブラウザ天地中央にセット
        const width = window.innerWidth
        const height = window.innerHeight
        const x = (width - this.initialWidth) / 2
        const y = (height - this.initialHeight) / 2
        this.initialPosition = [x, y]

        this.getData()
      } else {
        setTimeout(this.resetPosition, 300)
      }
    },
  },
  created() {},
  mounted() {
    this.$emit('require-inner-item', el => {
      this.$refs.wndInner.appendChild(el)
      //（v-show=falseの時は要素の高さが取れないので初期化しない）
      if (this.visible && this.$el) {
        this.setInitialState()
      }
    })
  },
  methods: {
    async getData() {
      await this.getConvertSummary()
      await this.getConvertResult()
    },
    // サマリーデータ 取得
    async getConvertSummary() {
      await ConvertRepository.getSummary(this.user.shop_id, this.type)
        .then(res => {
          if (res.result) {
            this.$store.dispatch('ConvertSummary/set', res.data)
          } else {
            alert('サマリー情報に失敗しました。')
            this.$store.commit('ConvertSummary/setSummary', [])
          }
        })
        .catch(e => {
          console.log(e)
          alert('サマリー情報の取得に失敗しました。')
        })
    },
    // コンバートデータ 取得
    async getConvertResult() {
      await ConvertRepository.getResult(this.user.shop_id)
        .then(res => {
          if (res.result) {
            this.$store.commit('ConvertSummary/setResult', res.data[0].portal_sites)
          } else {
            alert('サマリー情報に失敗しました。')
            this.$store.commit('ConvertSummary/setResult', [])
          }
        })
        .catch(e => {
          console.log(e)
          alert('サマリー情報に失敗しました。')
        })
    },
    // サマリーwindowの表示位置をリセット
    resetPosition() {
      // window表示位置をブラウザ天地中央にセット
      let width = window.innerWidth
      let height = window.innerHeight
      let x = (width - this.width) / 2
      let y = (height - this.height) / 2
      this.x = x
      this.y = y
    },
    //
    //  Initialize
    //
    enter: function() {
      this.setInitialState()
    },
    setInitialState: function() {
      //v-ifなどで要素自体が取れない場合は処理を中断
      if (!this.$el || !this.$refs.wndInner) return
      let buttonItemRect = null
      let innerItemRect = this.$refs.wndInner.getBoundingClientRect()
      this.width = this.initialWidth || innerItemRect.width
      this.height = (this.initialHeight || innerItemRect.height) + 22 + (buttonItemRect ? buttonItemRect.height : 0)

      if (this.initialPosition && this.initialPosition.length === 2) {
        this.x = this.initialPosition[0]
        this.y = this.initialPosition[1]
      } else {
        this.x = window.innerWidth / 2 - this.$el.clientWidth / 2
        this.y = window.innerHeight / 2 - this.$el.clientHeight / 2
      }
    },
    // Change position
    mousedown: function(e) {
      this.cursorOffset.x = e.pageX
      this.cursorOffset.y = e.pageY
      this.cursorStartPos = { x: this.x, y: this.y }
      document.addEventListener('mousemove', this.mousemove)
      document.addEventListener('mouseup', this.mouseup)
    },
    mousemove: function(e) {
      this.x = this.cursorStartPos.x + (e.pageX - this.cursorOffset.x)
      this.y = this.cursorStartPos.y + (e.pageY - this.cursorOffset.y)
    },
    mouseup: function(e) {
      console.log(e)
      this.cursorStartPos = null
      document.removeEventListener('mousemove', this.mousemove)
      document.removeEventListener('mouseup', this.mouseup)
    },

    //
    //  Resize window
    //

    startSizeChange: function(e) {
      let wndRect = this.$el.getBoundingClientRect()
      this.stateAtSizeChangeStarted = {
        width: wndRect.width,
        height: wndRect.height,
        cursorX: e.pageX,
        cursorY: e.pageY,
      }
      document.addEventListener('mousemove', this.whileSizeChange, false)
      document.addEventListener('mouseup', this.endSizeChange, false)
    },
    whileSizeChange: function(e) {
      this.width = this.stateAtSizeChangeStarted.width + e.pageX - this.stateAtSizeChangeStarted.cursorX
      this.height = this.stateAtSizeChangeStarted.height + e.pageY - this.stateAtSizeChangeStarted.cursorY
    },
    endSizeChange: function(e) {
      console.log(e)
      document.removeEventListener('mousemove', this.whileSizeChange, false)
      document.removeEventListener('mouseup', this.endSizeChange, false)
      this.setLocalStrage()
    },

    setLocalStrage() {
      let summaryWindowParams = {
        width: this.width,
        height: this.height,
      }
      localStorage.setItem('summaryWindowParams', JSON.stringify(summaryWindowParams))
    },
    //
    //  Buttons
    //
    closeButtonClicked: function() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.wnd_outer {
  position: fixed;
  background-color: white;
  width: 100%;
  height: 100%;
  border-radius: 3px;
  border: 1px solid #2d8cf0;
  border-radius: 5px 5px 0 0;
  z-index: 1000;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.caption {
  width: 100%;
  height: 22px;
  background-color: #2d8cf0;
  color: #fff;
  padding: 0;
  box-sizing: border-box;
  font-size: 9pt;
  padding: 4px 0 4px 10px;
  position: relative;
  &:hover {
    cursor: move;
  }
}
.close {
  font-size: 18px;
  position: absolute;
  top: 2px;
  right: 2px;
  color: white;
  cursor: pointer;
}
.mod_size {
  position: absolute;
  bottom: 0px;
  right: 0px;
  width: 10px;
  height: 10px;
  overflow: hidden;
  span {
    display: block;
    position: absolute;
    width: 120%;
    height: 1px;
    background-color: #c0c0c0;
    transform: rotate(-45deg);
  }
}
.wnd_inner {
  width: 100%;
  height: calc(100% - 22px);
  padding: 8px 16px;
  position: relative;
  overflow: scroll;
}
.wnd_inner_withbtn {
  height: calc(100% - 67px);
}
.wnd_button_outer {
  position: absolute;
  width: 100%;
  height: 45px;
  text-align: center;
}
.button_item {
  height: 30px;
  min-width: 90px;
  padding: 5px 15px;
  margin-top: 9px;
  margin-left: 5px;
  border-style: solid;
  border-color: #fff;
  border-width: 1px 3px 3px 1px;
  border-radius: 3px;
  background-color: #fff;
  color: #fff;
  cursor: pointer;
  position: relative;
  box-sizing: border-box;
  display: inline-block;
  vertical-align: top;
}
.button_item:active {
  border-width: 1px;
  top: 2px;
  left: 2px;
}

.v-enter-active {
  transition: opacity 1s, transform 0.5s;
}
.v-leave-active,
.v-leave-to {
  opacity: 0;
}
.v-enter {
  opacity: 0;
  transform: translateY(20px);
}
</style>
